module.exports = __webpack_public_path__ + "2152e44b9db3b85c8965e97ebd2e629d.pdf";